// Projeto Supabase próprio do My Planner (separado do Mestre Achado).
// Estes dois valores são públicos (a "publishable key" foi feita para ficar dentro do app).
// Nunca coloque aqui a chave secreta (secret / service_role).
export const SUPABASE_URL = 'https://spzzvvdbvjgqqiibjaqm.supabase.co';
export const SUPABASE_KEY = 'sb_publishable_sv9YcJ95CriM5t8KurHjSQ_db1g1RkB';

// Endereço do My Planner Web (EAS Hosting). Aparece em Ajustes > My Planner Web.
export const WEB_URL = 'https://www.myplanneranne.com';   // 0.73: domínio próprio (o myplanner.expo.app continua funcionando)

// Sempre o APK mais recente (a função "apk" do servidor pergunta à Expo e redireciona).
export const APK_URL = `${SUPABASE_URL}/functions/v1/apk`;

// Links das lojas (0.65, Texto 4 E): os convites mandam para a loja, não mais para o APK.
export const LOJA_ANDROID = 'https://play.google.com/store/apps/details?id=br.com.ravasco.myplanner';
export const LOJA_IOS = 'https://apps.apple.com/app/id6821125979';

// Loja (0.64): chaves PÚBLICAS do RevenueCat (Project settings > API keys). Podem ficar dentro do app.
// Android começa com "goog_", iPhone com "appl_". Enquanto estiverem vazias, o app segue com a assinatura simulada.
// Nunca coloque aqui a chave secreta do RevenueCat (começa com "sk_"): ela fica só no servidor.
export const RC_ANDROID = '';
export const RC_IOS = '';
